export default "__VITE_ASSET__CWXewSPC__"